import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService, NotificationsService, UserService } from '../_services';
import { forkJoin } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResetPasswordTokenGuard implements CanActivate {

  constructor(private _userService: UserService, private _authService: AuthenticationService, private _router: Router) { }
  
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const { token, userId } = route.params || {};

    try {
      this._userService.validateResetPasswordToken(userId, token).subscribe( res => {
        // ...
      }, err => {
        this._router.navigate(["/login/reset-password"]);
      })
      return true;
    } catch {
      this._router.navigate(["/login/reset-password"]);
      return false;
    }

  }

}